import Vue from "vue";
import App from "./App.vue";
import router from "./router/routerSite.js";
import VueSmoothScroll from "vue2-smooth-scroll";
Vue.use(VueSmoothScroll, {
  duration: 1500,
  updateHistory: false,
  offset: -80,
});
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);



// Per-route <title> and meta tags, sourced from public/meta_descriptions.json.
// Fetched once and cached; navigation is never blocked on it.
let metaCache = null;

function setMetaContent(selector, value) {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute("content", value);
}

function absoluteUrl(path) {
  const base = (process.env.VUE_APP_DOMAIN || "/").replace(/\/+$/, "");
  return base + path;
}

async function applyRouteMeta(to) {
  try {
    if (!metaCache) {
      metaCache = await fetch("/meta_descriptions.json").then((r) => r.json());
    }
  } catch (e) {
    return; // meta file unavailable — leave the defaults from index.html in place
  }

  // Fall back to the home entry so an unmapped route never ends up untitled.
  const meta = metaCache[to.path] || metaCache["/"];
  if (!meta) return;

  document.title = meta.title;
  setMetaContent("meta[name='title']", meta.title);
  setMetaContent("meta[name='description']", meta.description);
  setMetaContent("meta[name='keywords']", meta.keywords);
  setMetaContent("meta[property='og:title']", meta.title);
  setMetaContent("meta[property='og:description']", meta.description);
  setMetaContent("meta[property='og:url']", absoluteUrl(to.path));
  setMetaContent("meta[name='twitter:title']", meta.title);
  setMetaContent("meta[name='twitter:description']", meta.description);

  const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) canonical.setAttribute("href", absoluteUrl(to.path));
}

router.afterEach((to) => {
  applyRouteMeta(to);
});

new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
}).$mount("#app");
